module.exports = __webpack_public_path__ + "img/madden_header-image_1920x1080.4b10ff1d.jpg";